import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-delete-request-user',
  templateUrl: './delete-request-user.component.html',
  styleUrls: ['./delete-request-user.component.scss']
})
export class DeleteRequestUserComponent implements OnInit {

  ngOnInit(): void {

  }
  deleteForm: FormGroup;
  isSubmitting = false;
  constructor(
    private fb: FormBuilder,
    private CommonService: CommonService,
    private router: Router
  ) {
    this.deleteForm = this.fb.group({
      role: ['Customer', Validators.required],
      email: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', [Validators.required, Validators.minLength(3)]],
      removalReason: ['', Validators.required]

    });
  }
  onSubmit(): void {
    if (this.deleteForm.invalid) {
      this.deleteForm.markAllAsTouched();
      return;
    }
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        this.confirmDelete(); 
      }
    });
  }
  confirmDelete(): void {
    this.isSubmitting = true;
    const formData = this.deleteForm.value;

    this.CommonService.deleteAccount(formData).subscribe({
      next: (response) => {
        if (response.status) {
          Swal.fire(
            'Deleted!',
            'Your account has been deleted.',
            'success'
          ).then(() => {

            this.router.navigate(['/']); 
          });
        } else {
          Swal.fire(
            'Error!',
            'Something went wrong. Please try again later.',
            'error'
          );
        }
        this.isSubmitting = false;
      },
      error: (err) => {
        Swal.fire(
          'Error!',
          'Invalid Email or Phone number.',
          'error'
        );
        this.isSubmitting = false;
      }
    });
  }
}
